import { env } from "@papier/env/env-frontend";
import posthog from "posthog-js";

let initialized = false;

export function isPostHogEnabled() {
  return Boolean(env.VITE_POSTHOG_KEY);
}

export function initPostHog() {
  if (initialized || !isPostHogEnabled()) return;
  initialized = true;
  const defaultHost = env.VITE_SERVERSIDE_HOST
    ? `${env.VITE_SERVERSIDE_HOST.replace(/\/$/, "")}/api/posthog`
    : "/api/posthog";
  posthog.init(env.VITE_POSTHOG_KEY as string, {
    api_host: env.VITE_POSTHOG_HOST || defaultHost,
    // EU cloud default; backend proxy avoids adblockers.
    // Full capture requested: do not mask inputs/text.
    // Passwords and credit-card autofill are still masked by PostHog by default.
    defaults: "2025-11-30",
    capture_pageview: false,
    capture_pageleave: true,
    capture_exceptions: true,
    session_recording: {
      maskAllInputs: false,
    },
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.debug(false);
    },
  });
}

export { posthog };

export function identifyUser(input: {
  userId: string;
  email?: string | null;
  name?: string | null;
  organizationId?: string | null;
  organizationName?: string | null;
}) {
  if (!isPostHogEnabled()) return;
  posthog.identify(input.userId, {
    email: input.email ?? undefined,
    name: input.name ?? undefined,
    organization_id: input.organizationId ?? undefined,
    organization_name: input.organizationName ?? undefined,
  });
  if (input.organizationId) {
    posthog.group("organization", input.organizationId, {
      name: input.organizationName ?? undefined,
    });
  }
}

export function resetPostHog() {
  if (!isPostHogEnabled()) return;
  posthog.reset();
}
